var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Template_Outline-18px",
    "data-name": "Template Outline-18px",
    transform: "translate(-512 -728)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    width: 18,
    height: 18,
    transform: "translate(512 728)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "reader-outline_2_",
    "data-name": "reader-outline (2)",
    transform: "translate(419 681.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 12,
    height: 16,
    rx: 2,
    transform: "translate(96 47.403)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M176,128h5.792M176,131.042h5.792M176,134.084h2.9",
    transform: "translate(-77.104 -77.396)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateShowIcon);
export default __webpack_public_path__ + "static/media/template-show-icon.3dbc9c36aa6b2f20029a4f73444e9367.svg";
export { ForwardRef as ReactComponent };